import React from "react"

const HeaderComponent = () => {
  return <></>
}

export const Header = HeaderComponent
